import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const applicationService = {
  submitApplication: async (applicationData) => {
    try {
      console.log('Sending data:', applicationData);
      const response = await api.post('/applications', applicationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getApplications: async () => {
    try {
      const response = await api.get('/applications');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateApplicationStatus: async (id, status) => {
    try {
      const response = await api.put(`/applications/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default applicationService;